const styles = {
  title: {
    fontSize: '29px',
    margin: '0',
    paddingLeft: '7px',
  },
};

export default styles;
